import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { ImageSlot } from "@/components/common/ImageSlot";
import { btn, accent } from "@/lib/ui";

export const MeetDoctor = () => {
  const { content } = useSite();
  return (
    <section className="section relative overflow-hidden bg-gradient-to-br from-brand-tint via-white to-brand-greenTint" aria-labelledby="doctor-heading">
      <span className="blob -left-20 top-10 h-64 w-64 bg-brand-sky/20" aria-hidden="true" />
      <div className="container-x relative grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="relative mx-auto w-full max-w-md lg:col-span-5">
          <span className="absolute -inset-3 rotate-3 rounded-[2.25rem] bg-gradient-to-br from-brand-sky/50 via-brand-blue/20 to-brand-lime/50" aria-hidden="true" />
          <ImageSlot image={content.doctor_portrait} label={`${content.doctor_name} – portrait`} testid="home-doctor-portrait" className="relative shadow-xl" />
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow">Meet the doctor</p>
          <h2 id="doctor-heading" className="font-heading text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">{content.doctor_name}</h2>
          <p className="mt-2 text-lg font-medium text-brand-blue">{content.doctor_designation}</p>
          <ul className="mt-5 flex flex-wrap gap-2" aria-label="Credentials">
            {content.doctor_credentials.split(",").map((c, i) => (
              <li key={c} className={`rounded-full px-3 py-1 text-sm font-semibold ring-1 ring-black/5 ${accent(i).soft} ${accent(i).text}`}>{c.trim()}</li>
            ))}
          </ul>
          <p className="mt-3 text-sm text-slate-600" data-testid="home-doctor-registration">{content.doctor_registration}</p>
          <p className="mt-6 text-base leading-relaxed text-slate-700 md:text-lg">{content.doctor_short_bio}</p>
          <Link to="/about" className={`${btn("outline", "md")} mt-8`} data-testid="home-about-link">
            About Dr. Singh <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};
